import { createReducer, on } from '@ngrx/store';
import * as NotificationActions from './notification.actions';
import {NotificationState } from './notification.model';

export const initialState: NotificationState = {
  hasErrror: false,
  isLoading: false,
  isLoaded: false,
  items: {
    approval_pending: [],
    submission_pending: [],
    validation_pending: [],
  },
};

const onLoadNotifications = (state: NotificationState) => ({
  ...state,
  isLoading: true,
  hasErrror: false,
});

const onLoadNotificationsSuccess = (
  state: NotificationState,
  { items }: { items: any }
) => ({
  ...state,
  isLoading: false,
  isLoaded: true,
  items,
});

const onLoadNotificationsFailure = (state: NotificationState) => ({
  ...state,
  isLoading: false,
  isLoaded: false,
  hasErrror: true,
});

const onReset = () => initialState;

export const notificationReducer = createReducer(
  initialState,
  on(NotificationActions.loadNotifications, onLoadNotifications),
  on(NotificationActions.loadNotificationsSuccess, onLoadNotificationsSuccess),
  on(NotificationActions.loadNotificationsFailure, onLoadNotificationsFailure),
  on(NotificationActions.reset, onReset)
);
